var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v(" Reverse Pickup Product Details ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{required: true,alpha_num: true}"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping Id",
      "autocomplete": "off",
      "name": "shippingId"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shippingId')),
      expression: "errors.has('shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('shippingId')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isTableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isTableLoading = $event
      }
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShipmentDetails),
      expression: "showShipmentDetails"
    }]
  }, [_c('legend', [_vm._v(" Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm mb-2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "mt-2 overflow-auto table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.customer.name == null ? _vm.temp : _vm.customer.name))]), _vm._v(" "), _c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.ShipmentStatus == null ? _vm.temp : _vm.ShipmentDetails.ShipmentStatus))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Customer Address")]), _vm._v(" "), _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.customer.address == null ? _vm.temp : _vm.customer.address))]), _vm._v(" "), _c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Customer Pincode")]), _vm._v(" "), _c('td', {
    staticClass: "bg-white"
  }, [_vm._v(_vm._s(_vm.customer.pincode == null ? _vm.temp : _vm.customer.pincode))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Customer State")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.customer.state == null ? _vm.temp : _vm.customer.state))]), _vm._v(" "), _c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("IsDeliveryWithReversePickup")]), _vm._v(" "), _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.IsDeliveryWithReversePickUp == null ? _vm.temp : _vm.ShipmentDetails.IsDeliveryWithReversePickUp))])]), _vm._v(" "), _c('tr', [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.IsSku),
      expression: "!IsSku"
    }],
    staticClass: "text-center heading"
  }, [_vm._v("Return Reason")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.IsSku),
      expression: "!IsSku"
    }],
    staticClass: "bg-white",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.ReturnReason == null ? _vm.temp : _vm.ShipmentDetails.ReturnReason))]), _vm._v(" "), _c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Net Payment")]), _vm._v(" "), (!_vm.IsSku) ? _c('td', {
    staticClass: "bg-white"
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.NetPayment == null ? _vm.temp : _vm.ShipmentDetails.NetPayment))]) : _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.NetPayment == null ? _vm.temp : _vm.ShipmentDetails.NetPayment))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("Reverse AWB")]), _vm._v(" "), (_vm.IsMPS) ? _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.ShippingId == null ? _vm.temp : _vm.ShipmentDetails.ShippingId))]) : _vm._e(), _vm._v(" "), (!_vm.IsMPS) ? _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.ShippingId == null ? _vm.temp : _vm.ShipmentDetails.ShippingId))]) : _vm._e(), _vm._v(" "), (_vm.IsMPS) ? _c('th', {
    staticClass: "text-center heading"
  }, [_vm._v("MPSID")]) : _vm._e(), _vm._v(" "), (_vm.IsMPS) ? _c('td', {
    staticClass: "bg-white",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentDetails.MultiShipmentGroupID == null ? _vm.temp : _vm.ShipmentDetails.MultiShipmentGroupID))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProductDetailsTable),
      expression: "showProductDetailsTable"
    }],
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h6', {
    staticClass: "header-label1"
  }, [_vm._v(" Product Details : ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isProductDetailsTableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isProductDetailsTableLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables mt-2 product-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Product ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("POID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Prod. Qty")]), _vm._v(" "), (_vm.IsSku) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Return Reason")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client Product Images")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TLQC Images")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('tbody', [(_vm.productsArr.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((this.productsArr), function(data, index) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ShipmentDetails.OrderNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProductQty))]), _vm._v(" "), (_vm.IsSku) ? _c('td', [_vm._v(_vm._s(data.ReturnReason))]) : _vm._e(), _vm._v(" "), (_vm.isImages) ? _c('td', [_vm._l((data.PickupProductImage), function(image, index) {
      return _c('a', {
        key: index,
        staticStyle: {
          "text": "blue",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "Client Image",
          "alt": "Client Image"
        }
      })])
    }), _vm._v(" "), (data.PickupProductImage && data.PickupProductImage.length) ? _c('div', [_c('a', {
      staticClass: "view-images-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openImageViewer(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View Images\n                ")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isImages) ? _c('td', [_c('div', {
      class: _vm.isRVPdropoff ? 'image-grid' : ''
    }, _vm._l((data.SRPickDoneImages), function(image, index) {
      return (image && image.ImageUrl) ? _c('a', {
        key: index,
        staticStyle: {
          "text-decoration": "none",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": _vm.isRVPdropoff ? image.value : 'SR Image',
          "alt": "SR Image"
        }
      })]) : _vm._e()
    }), 0), _vm._v(" "), (data.SrPartialReversePickupImages && data.SrPartialReversePickupImages.length) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), (data.SrPartialReversePickupImages && data.SrPartialReversePickupImages.length) ? _c('div', _vm._l((data.SrPartialReversePickupImages), function(image, index) {
      return _c('a', {
        key: index,
        staticStyle: {
          "text": "blue",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "SR Image",
          "alt": "SR Image"
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), ((data.SRPickDoneImages && data.SRPickDoneImages.length) || (data.SrPartialReversePickupImages && data.SrPartialReversePickupImages.length)) ? _c('div', [_c('a', {
      staticClass: "view-images-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openImageViewer(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View Images\n                  ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isImages) ? _c('td', [(data.TLQCImages && data.TLQCImages.length) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col",
      staticStyle: {
        "width": "max-content"
      }
    }, _vm._l((data.TLQCImages), function(image, index) {
      return _c('a', {
        key: index,
        staticStyle: {
          "text": "blue",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "SR Image",
          "alt": "SR Image"
        }
      })])
    }), 0)]) : _vm._e(), _vm._v(" "), (data.TLQCSealImages && data.TLQCSealImages.length) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true)]) : _vm._e(), _vm._v(" "), (data.TLQCSealImages && data.TLQCSealImages.length) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, _vm._l((data.TLQCSealImages), function(image, index) {
      return _c('a', {
        key: index,
        staticStyle: {
          "text": "blue",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "SR Image",
          "alt": "SR Image"
        }
      })])
    }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isImages && data.WHImages && data.WHImages.length) ? _c('td', _vm._l((data.WHImages), function(image, index) {
      return _c('a', {
        key: index,
        staticStyle: {
          "text": "blue",
          "font-size": "0.9rem"
        },
        attrs: {
          "href": image.ImageUrl,
          "target": "_blank",
          "rel": "noreferrer"
        }
      }, [_c('img', {
        staticClass: "ImgStyles",
        attrs: {
          "src": image.ImageUrl,
          "title": "WHhandover Image",
          "alt": "WHhandover Image"
        }
      })])
    }), 0) : _vm._e()])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShipmentLogTable),
      expression: "showShipmentLogTable"
    }],
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h6', {
    staticClass: "header-label1"
  }, [_vm._v(" Shipment Log :")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isShipmentLogTableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isShipmentLogTableLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables mt-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [(_vm.shipmentLogs.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentLogs), function(data, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center",
      attrs: {
        "else": ""
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatedDate")(data.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))])])
  })], 2)])], 1)])]), _vm._v(" "), (_vm.imageViewerVisible) ? _c('div', {
    staticClass: "img-viewer-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeImageViewer.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "img-viewer-modal"
  }, [_c('div', {
    staticClass: "img-viewer-header"
  }, [_c('span', {
    staticClass: "img-viewer-title"
  }, [_vm._v("Image Preview")]), _vm._v(" "), _c('button', {
    staticClass: "img-viewer-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeImageViewer
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "img-viewer-body"
  }, [_c('div', {
    staticClass: "img-viewer-panel"
  }, [_c('div', {
    staticClass: "img-viewer-panel-title"
  }, [_vm._v("Client Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-viewer-scroll"
  }, [(!_vm.viewerClientImages || !_vm.viewerClientImages.length) ? _c('div', {
    staticClass: "img-viewer-empty"
  }, [_vm._v("No images")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.viewerClientImages), function(img, i) {
    return _c('a', {
      key: 'client-' + i,
      staticClass: "img-viewer-item",
      attrs: {
        "href": img.ImageUrl,
        "target": "_blank",
        "rel": "noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": img.ImageUrl,
        "alt": "Client Image",
        "title": "Client Image"
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "img-viewer-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "img-viewer-panel"
  }, [_c('div', {
    staticClass: "img-viewer-panel-title"
  }, [_vm._v("SR Clicked Images (During Pickup)")]), _vm._v(" "), _c('div', {
    staticClass: "img-viewer-scroll"
  }, [(!_vm.viewerSRImages || !_vm.viewerSRImages.length) ? _c('div', {
    staticClass: "img-viewer-empty"
  }, [_vm._v("No images")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.viewerSRImages), function(img, i) {
    return _c('a', {
      key: 'sr-' + i,
      staticClass: "img-viewer-item",
      attrs: {
        "href": img.ImageUrl,
        "target": "_blank",
        "rel": "noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": img.ImageUrl,
        "alt": img.value || 'SR Image',
        "title": img.value || 'SR Image'
      }
    })])
  }), _vm._v(" "), (_vm.viewerSRPartialImages && _vm.viewerSRPartialImages.length) ? [_c('div', {
    staticClass: "img-viewer-section-label"
  }, [_vm._v("SR Partial Pickup Image(s)")]), _vm._v(" "), _vm._l((_vm.viewerSRPartialImages), function(img, i) {
    return _c('a', {
      key: 'srp-' + i,
      staticClass: "img-viewer-item",
      attrs: {
        "href": img.ImageUrl,
        "target": "_blank",
        "rel": "noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": img.ImageUrl,
        "alt": "SR Partial Image",
        "title": "SR Partial Image"
      }
    })])
  })] : _vm._e()], 2)])])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-4 mt-1"
  }, [_c('span', [_vm._v(" Shipping ID: "), _c('i', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SR Clicked Images"), _c('br'), _vm._v("(During Pickup)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SR Clicked Images "), _c('br'), _vm._v("(During WH Handover)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('hr', {
    staticClass: "sr-partial-reverse-pickup-hr"
  }), _vm._v(" "), _c('strong', [_vm._v("SR Partial Pickup Image(s)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('hr', {
    staticClass: "images-col-hr"
  }), _vm._v(" "), _vm._v("\n                    Tlqc Seal Image(s)\n                  ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bag No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process Location")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Location")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comment")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5341f5ae","hasScoped":true}!./src/views/components/ReversePickupShipmentDetails/ReversePickupShipmentDetails.component.html
// module id = 1494
// module chunks = 1